var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-item" }, [
    _c(
      "a",
      { attrs: { href: _vm.product.url || _vm.url, title: _vm.product.title } },
      [
        _c(
          "div",
          { staticClass: "product-item__image" },
          [
            _vm.product.images.length
              ? _c("img", {
                  staticClass: "product-item__image lazyload",
                  attrs: {
                    "data-src": _vm._f("imageSize")(
                      _vm.product.images[0],
                      "500x"
                    ),
                    alt: _vm.product.title
                  }
                })
              : _vm._t("placeholder-image")
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }